import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo-white-without-text.png';
import './footer.css';

// Импорты иконок
import vkIco from '../../assets/icons/icons8-vk.svg';
import tgIco from '../../assets/icons/icons8-telegram.svg';
import yaIco from '../../assets/icons/yandex.png';
import avitoIco from '../../assets/icons/Avito_logo-white-text.png';

const VK_REF = 'https://vk.com/club220051052';
const TG_REF = 'https://t.me/kopstro';
const YA_REF = '#';
const AVITO_REF = 'https://www.avito.ru/brands/6402b21ca442ea7955dc837aec0b47d6';

function Footer() {
  return (
    <footer style={{ backgroundColor: 'var(--corp-dark)', borderTop: '4px solid var(--corp-accent)', color: 'white' }} className="pt-5 mt-auto">
      <Container className="pb-5">
        <Row className="gy-5">
          
          {/* 1. О компании */}
          <Col lg={4} md={12} className="text-center text-lg-start">
            <div className="d-flex align-items-center justify-content-center justify-content-lg-start mb-3">
              <Image src={logo} width="45" height="45" className="me-3" />
              <span className="fs-4 text-uppercase fw-bold m-0" style={{letterSpacing: '1px'}}>Комплекс строй</span>
            </div>
            <p className="text-white-50 small pe-lg-5">
              Профессиональные строительные и отделочные работы в Селятино и Московской области. Надежность и качество, проверенные временем.
            </p>
          </Col>

          {/* 2. Разделы навигации */}
          <Col lg={2} md={4} sm={6} className="text-center text-md-start">
            <div className="footer-column-title">Разделы</div>
              <div className="footer-nav">
                <Link to="/" className="footer-link">Главная</Link>
                <Link to="/catalog" className="footer-link">Каталог услуг</Link>
                <Link to="/about" className="footer-link">О компании</Link>
                <Link to="/working-area" className="footer-link">Где мы работаем</Link>
              </div>          
          </Col>

          {/* 3. Контакты */}
          <Col lg={3} md={4} sm={6} className="text-center text-md-start">
            <div className="footer-column-title">Контакты</div>
            <div className="mb-3">
              <a href="tel:+79251431299" className="text-white text-decoration-none fw-bold fs-5">
                +7 (925) 143-12-99
              </a>
              <div className="text-white-50 small mt-1">Ежедневно с 8:00 до 21:00</div>
            </div>
            <div className="text-white-50 small">
              <i className="bi bi-geo-alt-fill me-2" style={{color: 'var(--corp-accent)'}}></i>
              Московская обл., пос. Селятино
            </div>
          </Col>

          {/* 4. Соцсети */}
          <Col lg={3} md={4} className="d-flex flex-column align-items-center align-items-md-start">
            <div className="footer-column-title w-100 text-center text-md-start">Мы в сети</div>
            
            <div className="social-wrapper">
              <div className="social-list">
                <a href={VK_REF} target="_blank" rel="noreferrer" className="social-box" title="ВКонтакте">
                  <img src={vkIco} alt="vk" />
                </a>
                <a href={TG_REF} target="_blank" rel="noreferrer" className="social-box" title="Telegram">
                  <img src={tgIco} alt="tg" />
                </a>
                <a href={YA_REF} target="_blank" rel="noreferrer" className="social-box" title="Яндекс">
                  <img src={yaIco} alt="yandex" />
                </a>
              </div>

              <a href={AVITO_REF} target="_blank" rel="noreferrer" className="avito-box" title="Avito">
                <img src={avitoIco} alt="avito" />
              </a>
            </div>
          </Col>

        </Row>
      </Container>

      {/* 5. Нижняя панель (Sub-footer) */}
      <div className="footer-bottom">
        <Container>
          <Row className="align-items-center gy-3">
            
            <Col md={6} className="text-center text-md-start">
              <p className="copyright-text">
                © 2025 ООО «Комплекс строй» <span className="footer-dot"></span> Все права защищены
              </p>
            </Col>

            <Col md={6} className="text-center text-md-end d-flex justify-content-center justify-content-md-end">
              <a 
                href="https://kwork.ru/user/swrneko" 
                target="_blank" 
                rel="noreferrer" 
                className="dev-credit"
              >
                <svg 
                  width="14" height="14" viewBox="0 0 24 24" 
                  fill="none" stroke="currentColor" strokeWidth="2" 
                  strokeLinecap="round" strokeLinejoin="round" 
                  className="me-2" style={{ opacity: 0.5 }}
                >
                  <polyline points="16 18 22 12 16 6"></polyline>
                  <polyline points="8 6 2 12 8 18"></polyline>
                </svg>
                Design & Dev by <span>swrneko</span>
              </a>
            </Col>

          </Row>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
